import styled from "styled-components";

export const ProfileSettingBodySection = styled.div`
  width: 100%;
  height: 100%;
  padding-inline: 16px;
`;
